export default __webpack_public_path__ + "static/media/emblem.2e72cd41.png";